import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { DefultPageTitleService } from 'src/app/common-services/defult-page-title.service';
import { AlertService } from 'src/app/common-services/alert.service';
import { AuthService } from 'src/app/common-services/auth.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit, OnDestroy {
  contactForm: FormGroup;
  allSocialData: any;

  constructor(
    private PageTitle: DefultPageTitleService,
    private siteTitle: Title,
    private siteMeta: Meta,
    private alertService: AlertService,
    private authService: AuthService

) {
  this.PageTitle.mainHeaderTitle.next('आमचा संपर्क');
  this.PageTitle.subHeaderTitle.next('');
}

  ngOnInit(): void {

    this.contactForm = new FormGroup({
      nmpk_feedBackName:new FormControl(null, [Validators.required, Validators.minLength(3)]),
      nmpk_feedBackEmail: new FormControl(null, [Validators.required, Validators.email]),
      nmpk_feedBackMobile: new FormControl(null, [Validators.required, Validators.pattern('[0-9]*'),
      Validators.minLength(10), Validators.maxLength(10)]),
      nmpk_feedBack: new FormControl(null, [Validators.required, Validators.minLength(50)])
    });

    this.siteTitle.setTitle('Contact | Nagpur Mahanagarpalika Karmachari Sahakari Bank Ltd.');
    this.siteMeta.addTags([
      { name: 'keywords', content: 'Nagpur Mahanagarpalika Karmachari Sahakari Bank Ltd.'},
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Rahul Chamalwar' },
      {name: 'title', content: 'nmpksbank.in - Nagpur Mahanagarpalika Karmachari Sahakari Bank Ltd.'},
      { name: 'site', content: 'nmpksbank.in'},
      { property: 'og:image', content: 'https://nmpksbank.in/assets/img/logo.png'},
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      // { name: 'date', content: '2020-10-31', scheme: 'YYYY-MM-DD' },
      { charset: 'UTF-8' }
    ]);
    this.getAllSocialList();
  }

  getAllSocialList(){
    this.authService.showAllSocialLink()
    .subscribe( res => {
      if(res){
        this.allSocialData = res;
      }else{
        this.allSocialData = '';
      }
      // console.log(this.allSocialData);
    });
  }

  clearError(){
    this.alertService.clear();
  }


  contact() {
    this.authService.contact(this.contactForm)
    .subscribe((data: any) => {
      if (data){
       // If the request was successful notify the user
       this.alertService.heading.next('Great! It,s Success');
       this.alertService.success.next('Thank you for contact, We will contact you soon.');
       this.contactForm.reset();
      }else{
        this.alertService.heading.next('Opp,s Not Valid');
        this.alertService.info.next('Sorry, Server not found.');
      }
    },
    (error: any) =>
    {
      this.alertService.heading.next('Opp,s Sorry');
      this.alertService.error.next('Sorry It bad gateway?');
    });
    this.clearError();
  }

  ngOnDestroy(): void {
    this.PageTitle.mainHeaderTitle.next('');
    this.PageTitle.subHeaderTitle.next('');
    this.clearError();
  }
}
